/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { AxiosInstance } from 'axios';

import { Service } from '@hems/service/src/api/Service';
import { apiWrapper } from '@hems/service/src/util/apiHelper';
import { filterNilOrEmptyValues } from '@hems/util/src/helper/helper';

import type { CommonResponseWrapper } from 'hems';

import type { RecentActivity, ActivityHistoryQueryParams, ActivityHistoryResponse } from 'hems/activityHistory';

export default class ActivityHistoryService extends Service {
  constructor(axios: AxiosInstance) {
    super(axios);
  }

  getRecentActivityList = async (): Promise<RecentActivity[]> => {
    const { data } = await this.get<CommonResponseWrapper<RecentActivity[]>>(
      apiWrapper.managerApi('/managements/activities/dashboards')
    );

    return data;
  };

  getActivityList = async (params: ActivityHistoryQueryParams): Promise<ActivityHistoryResponse> => {
    return await this.get<ActivityHistoryResponse>(
      apiWrapper.managerApiV1('/site-activities'),
      filterNilOrEmptyValues(params)
    );
  };
}
